export default __webpack_public_path__ + "static/09-be111e4299825233aa0d18ebac1f0ba0.jpg";